import { Group } from "@mui/icons-material";
import { Box, Typography } from "@mui/material";

interface UserCountProps {
    count: number;
}

const UserCount = ({ count }: UserCountProps) => {
    return (
        <Box display="flex" alignItems="center" gap={0.5} color="text.secondary">
            <Group sx={{ fontSize: "14px" }} />
            <Typography variant="body2" fontSize="14px">
                {count}
            </Typography>
        </Box>
    );
};

export default UserCount;
